<template>
    <pause-question :stageId="stageId" :question="$t('PAUSE_DELIVERIES_SWITCH_TO_CLASSIC')" :updateSubscriptionText="$t('PAUSE_DELIVERIES_WOULD_YOU_SWITCH_TO_CLASSIC')" v-model="optionSelected" />
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import PauseQuestion from '@/components/partials/account/my-delivery-addresses/PauseQuestion';
import { PRODUCT_FAMILY_STANDARD } from '@/constants/Gifting';

export default {
    name: 'ClassicStep',
    components: { PauseQuestion },
    props: {
        pauseSurveyAnswer: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isNextStepClicked: false,
            optionSelected: null,
            stageId: 'classic',
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        ...mapGetters({
            userId: 'account/getUserId',
            activeSubscription: 'subscription/getActiveSubscription',
            primaryProducts: 'subscription/getProductTypes',
        }),
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
        selectedSubscription() {
            return this.activeSubscription;
        },
        standardBoxId() {
            return this.primaryProducts.filter(item => item.product_family.toLowerCase() === PRODUCT_FAMILY_STANDARD)[0]?.id;
        },
    },
    watch: {
        optionSelected() {
            if (this.optionSelected === 'update') {
                this.upgradeBox();
            } else if (this.optionSelected === 'continue') {
                this.nextStep();
            }
        },
    },
    methods: {
        upgradeBox() {
            this.$store.dispatch('subscription/updateProductType', { subId: this.selectedSubscription?.id, prodId: this.standardBoxId, name: PRODUCT_FAMILY_STANDARD })
                .then(() => {
                    this.$emit('subscription-updated');
                    this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
                })
                .catch(() => {});
        },
        nextStep() {
            this.isNextStepClicked = true;
            this.$emit('input', this.updatedSteps);
        },
    },
};
</script>
